import { CALL_HISTORY_METHOD, RESET_DATA } from 'Config/types';
import utils from 'Utils';
import viewReducer from './view';
import geosReducer from './geos';
import indicatorsReducer from './indicators';
import facetsReducer from './facets';

const { curry } = utils.fpHelpers;
const { shorten, getStringFromObject } = utils.query;
const { deepMerge } = utils.obj;

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching
 * your reducer or any middleware that comes after this one.
 */
export const routerMiddleware = (history, { getState }, next, action) => {
  if (action.type === RESET_DATA) {
    history.push({ search: '?view=0', query: '?view=0' });
  }

  if (action.type !== CALL_HISTORY_METHOD) {
    return next(action);
  }

  const { payload: { method, ...args } } = action;
  const { router: routingState } = getState();
  const viewChanged = (args.view && args.view !== routingState.view) || false;

  const newState = Object.keys(args)
    .reduce(routerReducer(routingState, args), {});

  const mergedState = deepMerge(routingState, newState);

  // Remove any empty values
  const cleanedState = Object.keys(mergedState)
    .reduce((acc, key) => (0 === mergedState[key].length ?
      acc :
      ({ ...acc, [key]: mergedState[key] })
    ), {});
  const stringState = getStringFromObject({ ...cleanedState });
  const shortString = shorten(stringState);
  const search = `?${shortString}`;

  history[method]({ viewChanged, search, query: search });
  // Do this so we can see it in the redux log
  return next(action);
};

/**
 * Reducing function for the routing state
 * @param  {object} routingState current routing state
 * @param  {object} args         args reducer called on
 * @return {function}            reducer callback
 */
function routerReducer(routingState, args) {
  return (acc, key) => {
    switch (key) {
      case 'batch': {
        const reducedBatch = args[key].reduce((acc1, item) => deepMerge(
          acc1,
          Object.keys(item).reduce(routerReducer(acc1, item), {})
        ), routingState);
        return deepMerge(acc, reducedBatch);
      }
      case 'view':
        return viewReducer(acc, args[key]);
      case 'geos':
        return geosReducer(acc, args[key], routingState);
      case 'indicators':
        return indicatorsReducer(acc, args[key], routingState);
      default:
        // assume this is indicator facets
        return facetsReducer(acc, args[key], key, routingState);
    }
  };
}

export default curry(routerMiddleware);



// WEBPACK FOOTER //
// ./app/middleware/router/index.js